import React from 'react';
import { Link } from 'react-router-dom';

const TermsAndCondition = () => {
    return (
        <div>
            <h3>Here is out Terms and Conditions</h3>
            <p>Go back TO <Link>Register</Link></p>
        </div>
    );
};

export default TermsAndCondition;